document.addEventListener('DOMContentLoaded', function() {
    const buttonsPictureImageZoom = document.querySelectorAll('[data-image-button-zoom]');
    buttonsPictureImageZoom.forEach(buttonPictureImageZoom => {
      const parentElement = buttonPictureImageZoom.parentElement;
      const imageZoom = parentElement.querySelector('img');
      imageZoom.addEventListener('click', () => {
        buttonPictureImageZoom.click();
      })
    });
  });	